var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0588 19.3978L16.4118 16.3076C16.9843 15.9772 17.2696 15.8125 17.4775 15.5821C17.6614 15.378 17.8003 15.1375 17.8853 14.8762C17.9804 14.5811 17.9804 14.2517 17.9804 13.5949V7.40465C17.9804 6.74779 17.9804 6.41838 17.8843 6.12328C17.7993 5.86201 17.6604 5.62152 17.4765 5.4174C17.2706 5.18798 16.9863 5.02328 16.4186 4.69583L11.0588 1.60171C10.4873 1.27132 10.202 1.10661 9.89804 1.04288C9.62915 0.985705 9.35125 0.985705 9.08236 1.04288C8.77843 1.10661 8.49314 1.27132 7.92157 1.60171L2.56667 4.69289C1.99608 5.0223 1.71078 5.187 1.50392 5.4174C1.32002 5.62152 1.18107 5.86201 1.09608 6.12328C1 6.41936 1 6.74877 1 7.40857V13.5899C1 14.2498 1 14.5801 1.09608 14.8752C1.18107 15.1365 1.32002 15.377 1.50392 15.5811C1.71078 15.8125 1.99706 15.9772 2.56765 16.3066L7.92059 19.3978C8.49314 19.7282 8.77843 19.8929 9.08236 19.9566C9.35098 20.0145 9.62942 20.0145 9.89804 19.9566C10.202 19.8929 10.4873 19.7282 11.0588 19.3978Z",
    stroke: "#E8C133",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54883 10.4998C6.54883 11.2798 6.8587 12.0279 7.41028 12.5795C7.96186 13.1311 8.70996 13.4409 9.49001 13.4409C10.2701 13.4409 11.0182 13.1311 11.5697 12.5795C12.1213 12.0279 12.4312 11.2798 12.4312 10.4998C12.4312 9.71972 12.1213 8.97162 11.5697 8.42004C11.0182 7.86847 10.2701 7.55859 9.49001 7.55859C8.70996 7.55859 7.96186 7.86847 7.41028 8.42004C6.8587 8.97162 6.54883 9.71972 6.54883 10.4998Z",
    stroke: "#E8C133",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.6adcfa6daf6070128676cec1222be197.svg";
export { ForwardRef as ReactComponent };